module.exports = __webpack_public_path__ + "img/sex_man.e0c3affd.png";